// extracted by mini-css-extract-plugin
module.exports = {"text":"mobile_text__1yEy6","title":"mobile_title__3_Y77","subtitle":"mobile_subtitle__2f6G1","wrap":"mobile_wrap__1xwH8"};